import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import apiClient from '../../../../../../api/apiClient';
import { usePreloaderStore } from '../../../../../../stores';
import { Endpoints, Defaults, SanctionEffect } from '../../../../../../views/democracy/constants';
import { extractErrorMessage } from '../../../../../../views/democracy/utils';
import { PlusIcon } from '../../../../model/icons';
import { resolveSanctionTypeLabel } from './sanctionsModel';
import SanctionCard from './SanctionCard';
import SanctionEditModal from './SanctionEditModal';

// Секция санкций одного типа: заголовок + добавление + сетка карточек.
export default function SanctionSection({ sanctionType, sanctions, democracyId, onChanged }) {
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const [editing, setEditing] = useState(null);

    const handleCreate = async () => {
        show();
        try {
            await apiClient.post(Endpoints.sanctions.createForDemocracy(democracyId), {
                sanctionType: sanctionType.name,
                effect: SanctionEffect.NONE,
                cost: 10,
                title: 'Новая санкция',
                description: null,
                maxConcurrent: Defaults.sanctionMaxConcurrent
            });
            onChanged();
            enqueueSnackbar('Санкция создана', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar(extractErrorMessage(error, 'Не удалось создать санкцию'), { variant: 'error' });
        } finally {
            hide();
        }
    };

    const sorted = [...sanctions].sort((a, b) => a.id - b.id);

    return (
        <section className="sanc-sec">
            <div className="sanc-sec-head">
                <h3>{resolveSanctionTypeLabel(sanctionType)} <span className="c">{sorted.length}</span></h3>
                <button type="button" className="btn btn-ghost btn-sm" onClick={handleCreate}>
                    <span className="ic"><PlusIcon /></span>Добавить санкцию
                </button>
            </div>

            {sorted.length === 0 ? (
                <div className="sanc-empty">Ещё нет санкций этого типа</div>
            ) : (
                <div className="sanc-grid">
                    {sorted.map(sanction => (
                        <SanctionCard key={sanction.id} sanction={sanction} onEdit={() => setEditing(sanction)} />
                    ))}
                </div>
            )}

            {editing && (
                <SanctionEditModal
                    key={editing.id}
                    sanction={editing}
                    onChanged={onChanged}
                    onClose={() => setEditing(null)}
                />
            )}
        </section>
    );
}

SanctionSection.propTypes = {
    sanctionType: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
    sanctions: PropTypes.array.isRequired,
    democracyId: PropTypes.number.isRequired,
    onChanged: PropTypes.func.isRequired
};
